"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTokenService = exports.accessTokenService = void 0;
var access_token_service_1 = require("./access-token.service");
Object.defineProperty(exports, "accessTokenService", { enumerable: true, get: function () { return access_token_service_1.accessTokenService; } });
Object.defineProperty(exports, "AccessTokenService", { enumerable: true, get: function () { return access_token_service_1.AccessTokenService; } });
